import { useEffect, useState } from 'react';

let artificialPrintEvent: Event;
if (typeof Event === 'function') {
    artificialPrintEvent = new Event('beforeprint');
} else {
    artificialPrintEvent = document.createEvent('Event');
    artificialPrintEvent.initEvent('beforeprint', true, true);
}

/**
 * This hook returns a function that triggers a re-render and calls window.print() after that next render is done.
 * Example:
 * const print = usePrint();
 * ...
 * <Button onClick={print} />
 */
export const usePrint = () => {
    const [timestamp, setTimestamp] = useState(0);

    useEffect(() => {
        if (timestamp > 0) {
            window.print();
        }
    }, [timestamp]);

    return () => {
        window.dispatchEvent(artificialPrintEvent);
        setTimestamp(Date.now());
    };
};
